import script from "./j6.vue?vue&type=script&setup=true&lang=js"
export * from "./j6.vue?vue&type=script&setup=true&lang=js"

import "./j6.vue?vue&type=style&index=0&id=351ebe49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351ebe49"]])

export default __exports__